import React from 'react';
import { styled, ThemeProps } from '@teko/ds-mobile';
import { getTrackingData } from '@teko/tracking';
import dynamic from 'next/dynamic';

const SearchOutlined = dynamic(() =>
  import('@teko/ds-icon').then((mod) => mod.StyledSearchOutlined),
);

interface HomeNavBarProps {
  placeholder: string;
  clickSearchBox?: () => void;
  right?: React.ReactNode;
  left?: React.ReactNode;
}

const StyledNavBar = styled.div(
  ({ theme }: ThemeProps) => `
    display: flex;
    align-items: center;
    justify-content: center;
    height: 3.5rem;
    background: ${theme?.colors.primary};
    padding: 0px 16px;

    & > *:not(:first-child) {
      margin-left: 16px;
    }
`,
);

export const SearchBox = styled.input`
  width: 100%;
  height: 2.25rem;
  background-color: #f6f6f6;
  border-radius: 0.5rem;
  outline: none;
  border: none;
  padding-left: 2.5rem;
  flex: 1;
`;

const Center = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
`;

const StyledSearchOutlined = styled(SearchOutlined)`
  position: absolute;
  left: 10px;
  top: 0;
  bottom: 0;
  z-index: 1;
  margin: auto;
`;

export const HomeNavBar: React.FC<HomeNavBarProps> = ({
  placeholder,
  clickSearchBox,
  left,
  right,
}: HomeNavBarProps) => (
  <StyledNavBar>
    {left}
    <Center
      {...getTrackingData({
        isTrackContent: true,
        regionName: 'headerBar',
        contentName: 'searchBox',
        target: 'searchProduct',
        payload: JSON.stringify({
          searchKeyword: '',
          ...(typeof window !== 'undefined'
            ? { href: window.location.href, url: window.location.href }
            : {}),
        }),
      })}
    >
      <StyledSearchOutlined size={20} />
      <SearchBox placeholder={placeholder} onClick={clickSearchBox} />
    </Center>
    {right}
  </StyledNavBar>
);
